/**
 * Search-readiness tier helpers — the leaf module for the "this document isn't
 * deep-indexed, more may be available" hint shown on citations.
 *
 * Tiers (from exploration_index_status, monotonically deeper):
 *   skim     — auto-summary only (no chunks)
 *   surface  — sampled-page chunks (default after auto-index)
 *   deep     — every-page chunks (full extraction)
 *   excluded — redacted copies, never indexed (terminal; not "upgradable")
 *
 * Kept dependency-light so both the witness reference rows and the document
 * viewer's evidence callout can share one vocabulary.
 */

export const TIER = Object.freeze({
  SKIM: 'skim',
  SURFACE: 'surface',
  DEEP: 'deep',
  EXCLUDED: 'excluded',
});

export const TIER_LABEL = Object.freeze({
  skim: 'Skim',
  surface: 'Surface',
  deep: 'Deep',
  excluded: 'Excluded',
});

/**
 * True when a document could reveal more if upgraded — i.e. it's indexed below
 * the deep tier. `excluded` (redacted copies) and `deep` are NOT below-deep, and
 * an unknown/missing tier is treated as skim (below deep).
 */
export function isBelowDeep(tier) {
  return tier === TIER.SKIM || tier === TIER.SURFACE || tier == null;
}

/** Human label for a tier value (falls back to the raw value). */
export function tierLabel(tier) {
  return TIER_LABEL[tier] || (tier ? String(tier) : '');
}
